<template>
  <div class="mt-6 lg:mt-0">
    <section-header size="sm" variants="dividing" class="pt-2 lg:pt-0">
      <heading :level="3">
        {{ title }}
      </heading>
    </section-header>
    <trek-button v-if="!totalFiltersSelected" secondary block
      icon-only
      icon="highlight_off"
      class="hide-for-large mt-2"
      :aria-label="bp('done')"
      data-close>
    </trek-button>
    <trek-button v-else primary
      block
      class="hide-for-large mt-2"
      data-close>
      <span v-html="bp('done')"></span>
    </trek-button>
  </div>
</template>

<script>
import Heading from '@/components/Heading';
import SectionHeader from '@/components/SectionHeader';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'FacetsHeader',

  components: {Heading, SectionHeader, TrekButton},

  props: {
    selectedFilters: {
      type: [Array, Object],
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    totalFiltersSelected() {
      return !this.selectedFilters ? 0 : this.selectedFilters.length;
    },
  },
};
</script>
